var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Số lượng ")]),_c('b-input',{attrs:{"type":"number","placeholder":"Nhập số lượng..."},model:{value:(_vm.entry.quantity),callback:function ($$v) {_vm.$set(_vm.entry, "quantity", $$v)},expression:"entry.quantity"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }